// extracted by mini-css-extract-plugin
export var checked = "PartnerForm-module--checked--8fe38";
export var label = "PartnerForm-module--label--bd312";